import React from 'react';
import Lottie from 'react-lottie';
import './Warning_Lottie.css';
import * as animationData from './Warning_Lottie.json';

function Warning_Lottie() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <section className='main'>
            <div className='Warning_Lottie_icon'>
                <Lottie className="me-auto"
                    options={defaultOptions}
                // height={60}
                // width={60}          
                />
            </div>
        </section>
    );
}
export default Warning_Lottie;